import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty.js";
import { endereco_empty } from "@/components/Form/Endereco/get_endereco_empty.js";

export const getPagination = ({ pagination }) => pagination;
export const biblioteca_empty = () => ({
  nome: "",
  files_count: 0,
});
